export const hexToRGBA = (hexCode, opacity) => {
  let hex = hexCode?.replace("#", "")

  if (hex?.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`
  }

  const r = parseInt(hex?.substring(0, 2), 16)
  const g = parseInt(hex?.substring(2, 4), 16)
  const b = parseInt(hex?.substring(4, 6), 16)

  return `rgba(${r},${g},${b},${opacity / 100})`
}

export const hexCodeToRgba = (hexCodeStr, opacity = 1) => {
  let c
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hexCodeStr)) {
    c = hexCodeStr.substring(1).split("")
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]]
    }
    c = "0x" + c.join("")
    return (
      "rgba(" +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
      `,${opacity})`
    )
  }
  throw new Error("Invalid Hexcode")
}
